import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Country } from '../../interfaces/cached-content';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';
import { GoogleTagService } from '../../services/google-tag/google-tag.service';

@Component({
  selector: 'app-country',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './country.component.html',
  styleUrl: './country.component.scss',
})
export class CountryComponent {
  public country = input.required<Country>();

  public theme = inject(THEME_SIGNAL);

  public GbTheme = GbTheme;

  private readonly router = inject(Router);
  private readonly gtmService = inject(GoogleTagService);

  public countrySelected = output<Country>();

  onCountryClick(): void {
    this.countrySelected.emit(this.country());
    this.router.navigate(['/', this.country().slug]);

    this.gtmService.pushEvent('view_plans_page', {
      location: this.country().name,
      location_type: this.country().regionType || 'country',
    });
  }
}
